<template>
  <vv-screen-wrapper>
    <div :class="`screen-container-${$mq}`">

      <simple-header
        :label="$t('lessonStep.intro.header')"
        @click="$router.push({ name: 'themeList' })"
      />
    

      <!-- Small devices layout -->
      <mq-layout :mq="['mobile', 'tablet']">

        <img class="img" :src="theme.tileImage">
        <div class="bodyTheme">
          <div class="theme-title">{{ title }}</div>
          <div class="author">Par {{theme.author.fullName}}</div>
          <div class="detailsTheme"  v-if="type === 'learn'">
            <div class="bodyDetailsTheme" v-for="lessonStep in lessonSteps" :key="lessonStep.id">
              <div>
                <div class="itemsTitle">{{lessonStep.title}}</div>
                <div class="items">
                  <div v-for="lesson in lessonStep.lessons" :key="lesson.id">
                    <img :src="lesson.tileImage" class="imgItems" @click="openLesson(lesson.id, lessonStep.id)">
                  </div>
                </div>
              </div>
              <div class="startMasterclass" @click="startLesson(lessonStep.lessons, lessonStep.id)">DEMARRER</div>
            </div>
            <div v-if="remoteConfig.getBoolean('quiz_enabled') && hasQuiz()" @click="generateAndOpenQuiz" class="quizButton">
              {{ $t('theme.quizButton') }}
            </div>
            <div v-if="showSwitches" @click="switchTab" class="quizButton">
              {{ button(type) }}
            </div>
          </div>
          <div v-else class="mobile-tasting">
            <div v-for="tasting in theme.tastings" :key="tasting.id" class="tating-mobile">
              <tasting-list-item :id="tasting.id"/>
            </div>
            <div v-if="showSwitches" @click="switchTab" class="quizButton">
              {{ button(type) }}
            </div>
          </div>
        </div>
      </mq-layout>

      <!-- Desktop layout -->
      <mq-layout mq="desktop">
        <div class="Desktop">
          <div class="Desktop-Title">{{ title }}</div>

          <div class="Desktop-ProgressBar-Wrapper">
            <vv-progress-bar :progression="progression" :total="total" class="progress-bar" />
          </div>

          <div v-if="type === 'learn' && lessonSteps.length">
            <desktop-lesson-step-item
              v-for="lessonStep in lessonSteps"
              :key="lessonStep.id"
              :id="lessonStep.id"
              :masterclassId="theme.id"
              :lessonStep="lessonStep"
            />
          </div>
          <div v-else class="desktop-tasting">
            <div v-for="tasting in theme.tastings" :key="tasting.id" class="desktop-tasting-item-wrapper">
              <tasting-list-item :id="tasting.id" />
            </div>
          </div>

          <desktop-masterclass-quiz-button
            v-if="remoteConfig.getBoolean('quiz_enabled') && hasQuiz()"
            :masterclassId="theme.id"
            @click="generateAndOpenQuiz"
          />
          <desktop-masterclass-switch-button v-if="showSwitches" @click="switchTab" :type="type" />
        </div>
      </mq-layout>
    </div>
  </vv-screen-wrapper>
</template>

<script>
import { mapGetters } from 'vuex'
import get from 'lodash/get'

import userMixin from '@/mixins/user'
import remoteConfigMixin from '@/mixins/remoteConfig'

import { GENERATE_RANDOM_QUIZ } from '@/store/modules/quiz/types'
import { contentHasQuiz } from '@/store/modules/quiz/actions'

import { isLessonStepComplete, isLessonStepStarted } from '@/helpers/userCompletion'

import { VvProgressBar, VvSpeechButton, VvBox, VvScreenWrapper } from '@/components/common'
import DownloadButton from '@/components/download/DownloadButton'

import SimpleHeader from '@/components/navigation/SimpleHeader'

import TastingListItem from '@/components/tasting/TastingListItem'

import LessonStepItem from '@/components/masterclass/LessonStepItem'
import DesktopLessonStepItem from '@/components/masterclass/DesktopLessonStepItem'
import DesktopMasterclassQuizButton from '@/components/masterclass/DesktopMasterclassQuizButton'
import DesktopMasterclassSwitchButton from '@/components/masterclass/DesktopMasterclassSwitchButton'
import content from "@/mixins/content";


export default {
  name: 'Theme',
  components: {
    SimpleHeader,
    VvProgressBar,
    VvSpeechButton,
    VvBox,
    LessonStepItem,
    DesktopLessonStepItem,
    TastingListItem,
    VvScreenWrapper,
    DesktopMasterclassQuizButton,
    DesktopMasterclassSwitchButton,
    DownloadButton
  },
  mixins: [userMixin, remoteConfigMixin, content],
  props: {
    whitch: {
      type: String,
      required: false,
      default: 'learn'
    },
  },
  data() {
    return {
      type: this.whitch,
    }
  },
  mounted() {

    this.assertHasAccessToContent(this.$route.params.themeId)
  },
  computed: {
    ...mapGetters({
      theme: 'currentTheme',
      funnels: 'themeFunnels',
      lessonStepDuration: 'lessonStepDuration',
      getThemeById: 'getThemeById'
    }),
    title() {
      if (!this.theme) return

      return this.theme.title
    },
    lessonSteps() {
      return this.theme ? this.theme.lessonSteps : []
    },
    progression() {
      if (!this.lessonSteps) return 0

      return this.lessonSteps.reduce(
        (accumulator, lessonStep) =>
          this.isLessonStepCompletes(lessonStep.id) ? accumulator + 1 : accumulator,
        0
      )
    },
    total() {
      if (!this.lessonSteps) return 0

      return this.lessonSteps.length
    },
    funnel() {
      return this.funnels[this.theme.id]
    },
    numberOfQuizQuestion() {
      return get(this.theme, 'numberOfQuestions', 2)
    },
    showSwitches() {
      return this.lessonSteps && this.theme.tastings && this.lessonSteps.length > 0 && this.theme.tastings.length > 0
      return this.lessonSteps && this.tastings && this.lessonSteps.length > 0 && this.tastings.length > 0
    }
  },
  methods: {
    startLesson(lessons, lessonStepId) {
      let id
      for (var i = 0; i < 1; i++) {
        id = lessons[i].id
      }
      this.$router.push({
        name: 'lesson',
        params: {
          themeId: this.theme.id,
          lessonStepId: lessonStepId,
          lessonId: id
        }
      })
    },
    openLesson(lessonId, lessonStepId) {
      // console.log(lessonId)
      this.$router.push({
        name: 'lesson',
        params: {
          themeId: this.theme.id,
          lessonStepId: lessonStepId,
          lessonId: lessonId
        }
      })
    },
    setType(type) {
      this.type = type
    },
    hasQuiz() {
      return contentHasQuiz('masterclass', this.theme.id, this.$store.state)

      if (this.theme) return contentHasQuiz('masterclass', this.theme.id, this.$store.state)
      else return false
    },
    isLessonStepCompletes(lessonStepId) {
      return isLessonStepComplete(lessonStepId)
    },
    lessonStepStatus(lessonStepId) {
      if (this.isLessonStepCompletes(lessonStepId)) {
        return 'finished'
      }

      if (isLessonStepStarted(lessonStepId)) return 'started'

      return 'unstarted'
    },
    generateAndOpenQuiz() {
      if (!this.remoteConfig.getBoolean('quiz_enabled')) return

      this.$store.dispatch(GENERATE_RANDOM_QUIZ, {
        contentType: 'masterclass',
        contentId: this.theme.id
      })

      this.$router.push({
        name: 'quiz',
        params: {
          quizId: this.theme.id,
          contentType: 'masterclass',
          contentId: this.theme.id
        }
      })
    },
    switchTab() {
      this.type = this.type === 'taste' ? 'learn' : 'taste'
    },
    button(type) {
      switch (type) {
        case 'taste':
          return this.$t('masterclass.switch.to_lesson.button')

        case 'learn':
        default:
          return this.$t('masterclass.switch.to_tasting.button')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';
.tating-mobile {
  margin: 15px 0px;
}
.startMasterclass {
  border-radius: 23px;
  background: #F0CF65;
  color: #fff;
  box-shadow: 2px 3px 6px #F0CF65;
  padding: 10px 15px;
  margin-bottom: 10px;
  font-size: 20px;
  text-align: center;
  width: 115px;
  margin-top: -20px;
  position: relative;
  top: 40px;
}
.quizButton {
  border-radius: 23px;
  background: #F0CF65;
  color: #fff;
  box-shadow: 2px 3px 6px #F0CF65;
  padding: 15px 30px;
  margin: 20px 0px;
  font-size: 20px;
}
.itemsTitle {
  padding: 10px;
}
.items {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin-left: -10px;
}
.imgItems {
  width: 140px;
  height: 120px;
  border-radius: 23px;
  margin-left: 10px;
}
.bodyDetailsTheme {
  display: flex;
  flex-direction: column;
  border-radius: 23px;
  box-shadow: 2px 3px 6px #b0b4cb;
  width: 80%;
  margin: 15px;
  padding: 10px;
  align-items: center;
}
.author {
  margin-left: 23px;
  background-color: #F7F8FC;
  border-radius: 23px;
  padding: 5px;
  box-shadow: 2px 3px 6px #b0b4cb;
  width: 100px;
  text-align: center;
}
.detailsTheme {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 70px;
}
.screen-container-desktop{
  margin: 0 auto;
  padding-top: 15px;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 70px;
}
.screen-container-mobile, .screen-container-tablet {
  padding-top: 20px;
}
.img{
  display: block;
  float: left;
  background-color: rgb(26, 39, 14);
  width: 100%;
  height: 200px;
}
.theme-title {
  font-size: 19px;
  font-weight: 900;
  margin-bottom: 12px;
  text-align: start;
  padding: 10px;
}
.bodyTheme {
  display: flex;
  flex-direction: column;
  border-radius: 20px 20px 0px 0px;
  background-color: #fff;
  text-align: start;
  margin-top: -20px;
  padding-top: 40px;
  width: 100%;
  height: 100%;
  float: left;
  margin-bottom: 70px;
}
.theme-button-container {
  padding: 0 10px;
  margin-top: 15px;
  display: flex;
  justify-content: space-evenly;

  .theme-button {
    width: 40%;

    &.first {
      margin-right: 10%;
    }
  }
}

.quiz-link {
  display: inline-block;
  width: 100%;
  text-align: center;
}

.Desktop {
  .Desktop-Title {
    font-size: 23px;
    font-weight: bold;
    color: $primary;
    text-align: center;
  }

  .Desktop-ProgressBar-Wrapper {
    margin-top: 10px;
    margin-bottom: 20px;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
  }

  .Desktop-Switches {
    margin-top: 10px;

    .Desktop-Switch {
      display: inline-block;
      width: 50%;
      padding: 20px;
      box-sizing: border-box;
    }
  }

  .Quiz-Cta {
    font-size: 14px;
    font-weight: bold;
    color: $primary;
    margin-bottom: 8px;
  }
}

.link {
  width: 50%;
  margin-bottom: 15px;
  display: inline-block;
  padding-right: 5px;
  padding-left: 5px;
}

.scan-button {
  position: absolute;
  border: none;
  outline: none;
  background: none;
  border-radius: 4px;
  right: 85px;
}
.scan-button:hover {
  cursor: pointer;
}
@media screen and (max-width: 420px) {
  .scan-button {
    right: 55px;
    img {
      width: 40px;
    }
  }
}
@media screen and (min-width: 1281px) {
  .scan-button {
    display: none;
  }
}
.geoloc-button {
  position: absolute;
  border: none;
  outline: none;
  background: none;
  border-radius: 4px;
  right: 10px;
}
.geoloc-button:hover {
  cursor: pointer;
}
@media screen and (max-width: 420px) {
  .geoloc-button {
    right: 5px;
    img {
      width: 40px;
    }
  }
}

.link-wrapper { 
  width: 50%;
  margin-bottom: 15px;
  display: inline-block;
  box-sizing: border-box;
  padding-right: 5px;
  padding-left: 5px;
}
.desktop-tasting {
  height: 100%;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
}
.mobile-tasting {
  height: 100%;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 70px;
}
.desktop-tasting-item-wrapper {
  margin-bottom: 15px;
  width: 33%;
  @media screen and (max-width: 1880px) {
    width: 38%;
  }
  @media screen and (max-width: 1224px){
    width: 55%;
  }
  display: inline-block;
  padding-right: 20px;
  box-sizing: border-box;
}

.DownloadButton {
  position: absolute;
  display: flex;
  align-items: center;
  right: 10px;

  > * {
    padding: 5px;
  }

  span {
    font-size: 10px;
  }
}
</style>
